import React from 'react';
import BootstrapSpinner from 'react-bootstrap/Spinner';

const Spinner = () => {
  const styleCenterAbsolute = {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: '50%',
    top: '50%',
    marginLeft: 'auto',
    marginRight: 'auto',
    zIndex: '9000',
  };

  return (
    <BootstrapSpinner animation="border" role="status" style={styleCenterAbsolute}>
      <span className="sr-only">Loading...</span>
    </BootstrapSpinner>
  );
};

export { Spinner };
